/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const RegionCode = zod
  .enum(['au', 'us'])
  .describe("One of OnEarly's regions: `au` (Australia) or `us` (United States).");

export type RegionCode = zod.input<typeof RegionCode>;
export type RegionCodeOutput = zod.output<typeof RegionCode>;
